// extracted by mini-css-extract-plugin
export default {"container":"_1EIQb","left":"_3swOY","right":"_3-uys"};